export default function formatTextUpperCase(text: string): string {
  return text.replace(/\b\w/g, (match) => match.toUpperCase());
}
